import * as React from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import WorkflowManagementScreen from './workflow';
import WorkflowExecutionDetails from './executionDetails';
import { kollectAITheme } from 'config/theme';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number, value: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    style: {
      background: value === index ? kollectAITheme.primaryColor : '#fff',
      borderRadius: '10px 10px 0 0',
      color: value === index ? '#fff' : '#000',
      fontWeight: '600',
      border: value !== index ? '1px solid #F0D8D8' : '',
      padding: '1rem 2rem',
    },
  };
}

export default function WorkflowPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', padding: '5px 0 0 10px' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'
        >
          <Tab label='Workflow Management' {...a11yProps(0, value)} />
          <Tab label='Workflow Execution Details' {...a11yProps(1, value)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <WorkflowManagementScreen />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <WorkflowExecutionDetails />
      </CustomTabPanel>
    </Box>
  );
}
